import { tenantId, tenantName } from 'config/envConfig';

/**
 * Reports config load errors to GTM dataLayer for monitoring.
 * Elastic APM (if present) also captures these via its error tracking.
 *
 * @param {'visual-config' | 'bootstrap'} configType
 * @param {Error} error
 */
export const reportConfigLoadError = (configType, error) => {
  const event = {
    event: 'dashboard.config.load.error',
    configType,
    tenantId,
    tenantName,
    errorMessage: error?.message || String(error),
    timestamp: new Date().toISOString(),
  };

  // Push to GTM dataLayer if available
  if (window.geoDatalayer) {
    window.geoDatalayer.push(event);
  } else if (window.dataLayer) {
    window.dataLayer.push(event);
  }

  // Elastic APM RUM agent (if loaded)
  if (window.elasticApm) {
    window.elasticApm.captureError(
      new Error(`Config load failed: ${configType} - ${error?.message}`),
    );
  }
};
